export const READ_VALVES_WITH_FILTER = "READ_VALVES_WITH_FILTER";
export const READ_VALVES_SENSOR_WITH_FILTER = "READ_VALVES_SENSOR_WITH_FILTER";
